<template>
  <div class="container-fluid max-container">
    <div class="row">
      <Header />
      <section>
        <div class="container">
          <div class="health-store-container">
            <div class="store-title-row">
              <h1>Store</h1>
              <div class="store-region-switcher" ref="regionSwitcherRef">
                <button class="store-region-switcher__trigger" type="button" @click.stop="toggleRegionDropdown">
                  <img
                    :src="currentRegionOption.flagSrc"
                    :alt="`${currentRegionOption.label} flag`"
                    class="store-region-switcher__flag"
                  />
                </button>
                <div v-if="showRegionDropdown" class="store-region-switcher__menu">
                  <button
                    v-for="region in regionOptions"
                    :key="region.code"
                    type="button"
                    class="store-region-switcher__option"
                    @click.stop="selectRegion(region.code)"
                  >
                    <img :src="region.flagSrc" :alt="`${region.label} flag`" class="store-region-switcher__flag" />
                    <span>{{ region.label }}</span>
                  </button>
                </div>
              </div>
            </div>
            <!-- tab module container starts here -->
            <div class="tab-module-wrapper">
              <div class="tab-module-wrapper-health-store" :class="tabCountClass">
                <template v-for="(tab, index) in tabs">
                  <div v-if="tab !== null" :key="index" @click="selectTab(index)"
                    :class="{ 'active-tab': selectedTab === index }" class="tab-module">
                    <img :src="selectedTab === index ? tab.activeIcon : tab.icon" alt="" />
                    <p class="mt-1 mb-0" :style="{
                      color: selectedTab === index ? 'blue' : 'black',
                      fontWeight: selectedTab === index ? 600 : 400,
                    }">
                      {{ tab.name }}
                    </p>
                  </div>
                </template>
              </div>
              <div v-if="loadingStatus === 'loading'" class="tab-module-progress" aria-hidden="true"></div>
            </div>
            <!-- <div class="clear-all-container" v-if="buildVersion !== 'dnanalysis'">
              <a href="#" class="clear" @click="handleClearAll">Clear all</a>
            </div> -->
            <PageLoader v-if="loadingStatus === 'loading'" />
            <!-- Open div based on the selected tab -->
            <div v-if="activeTabName === 'Digital Upgrades' && loadingStatus === 'loaded'">
              <UpgradesUnavailable v-if="upgradesBlockedFor" :barcode="profileBarcode" :status="upgradesBlockedFor" />
              <template v-else>
                <p class="head" v-if="digitalUpgradeList.length">{{ isEpigenetics ? 'Unlock more Epigenetic insights.' : 'Unlock more of your DNA story.' }}</p>
                <div class="mt-4 store-nodata" v-else>
                  <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                  <div class="store-nodata-text">
                    You have purchased all the Digital upgrades for this test currently. Keep checking back to discover
                    new tests.
                  </div>
                </div>
                <div class="content-tab-container" v-if="digitalUpgradeList.length">
                  <div
                    v-for="(store, index) in digitalUpgradeList"
                    :key="index">
                    <div class="card" v-if="!store.purchased">
                      <div v-if="!store.purchased" class="card-content">
                        <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                        <img :src="Bg4" v-else alt="" />
                        <div>
                          <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                          <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                            getPrice(store?.price) }}</p>
                        </div>
                      </div>
                      <div v-if="!store.purchased" class="card-hover-content">
                        <div class="card-content-hover">
                          <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                          <img :src="Bg1" v-else class="w-65" />
                          <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                          <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                            getPrice(store?.price) }}</p>
                        </div>
                        <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                        <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                          :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories) }}</router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
            <div v-if="activeTabName === 'Ancestry Kits'">
              <p class="head" v-if="ancestryKitList.length">Purchase additional ancestry kits at a discounted price</p>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  No ancestry kits are currently available. Keep checking back to discover new options.
                </div>
              </div>
              <div class="content-tab-container" v-if="ancestryKitList.length">
                <div v-for="(store, index) in ancestryKitList" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                    <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                      getPrice(store?.price) }}</p>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <div>
                        <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                      :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeTabName === 'Epigenetic Kits'">
              <p class="head" v-if="epigeneticKitList.length">Start your epigenetic journey with one of our kits</p>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  No epigenetic kits are currently available. Keep checking back to discover new options.
                </div>
              </div>
              <div class="content-tab-container" v-if="epigeneticKitList.length">
                <div v-for="(store, index) in epigeneticKitList" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg1" v-else />
                    <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                    <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                      getPrice(store?.price) }}</p>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <div>
                        <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <router-link :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                      :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeTabName === 'Vitamin Supplement'">
              <!-- Mixed from the Wellbeing results, so none is sold before they're in -->
              <WellbeingRequiredPrompt v-if="vitaminsNeedWellbeing" class="store-prompt" />
              <template v-else>
              <p class="head" v-if="storeList['Vitamins supplement']">Purchase a vitamin supplement based on your DNA
              </p>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  You have purchased all the Vitamins supplement upgrades for this test currently. Keep checking back to
                  discover new tests.
                </div>
              </div>
              <div class="content-tab-container" v-if="storeList['Vitamins supplement']">
                <div v-for="(store, index) in storeList['Vitamins supplement']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg3" v-else alt="" />
                    <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                    <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                      getPrice(store?.price) }}</p>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <div>
                        <h4 class="text-ellipsis">{{ store.title }}</h4>
                        <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                          getPrice(store?.price) }}</p>
                      </div>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <template v-if="isEpigenetics">
                      <router-link :to="{ name: 'HealthStore', query: { tab: 'ancestrykits' } }" class="explore-btn">Requires an ancestry kit</router-link>
                    </template>
                    <router-link v-else :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn">{{
                      buttonText(store.categories) }}</router-link>
                  </div>
                </div>
              </div>
              </template>
            </div>
            <div v-if="activeTabName === 'Merchandise'">
              <p class="head" v-if="storeList['Merchandise']">Take your DNA offline with premium merchandise.</p>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  You have purchased all the Merchandise upgrades for this test currently. Keep checking back to
                  discover new tests.
                </div>
              </div>
              <div class="content-tab-container" v-if="storeList['Merchandise']">
                <div v-for="(store, index) in storeList['Merchandise']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                    <img :src="Bg4" v-else alt="" />
                    <div>
                      <h4 :class="store.locked ? 'disable-color' : ''">{{ store.title }}</h4>
                      <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                        getPrice(store?.price) }}</p>
                    </div>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store.image" class="img-thumbnails" alt="" v-if="store.image !== ''" />
                      <img :src="Bg1" v-else class="w-65" />
                      <h4 :class="store.locked ? 'text-ellipsis disable-color' : 'text-ellipsis'">{{ store.title }}</h4>
                      <p :class="store.locked ? 'price disable-color' : 'price'">{{ store?.currencySymbol?.raw }} {{
                        getPrice(store?.price) }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="getDesc(store.shortDescription)"></span>
                    <template v-if="isEpigenetics">
                      <router-link :to="{ name: 'HealthStore', query: { tab: 'ancestrykits' } }" class="explore-btn">Requires an ancestry kit</router-link>
                    </template>
                    <router-link v-else :to="{ name: 'AncestryDetails', params: { slug: store.slug } }" class="explore-btn"
                      :class="{ 'disabled-link': store.locked }">{{ buttonText(store.categories, store) }}</router-link>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="activeTabName === 'Health Reports'">
              <!-- A report is made from the kit's DNA results, so none is sold before they're in -->
              <GeneticReportsNotice v-if="reportsWaitForResults" />
              <template v-else>
              <p class="head" v-if="productList['Genetic Test']">Genetic Reports</p>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  You have purchased all the Genetic Reports upgrades for this test currently. Keep checking back to
                  discover new tests.
                </div>
              </div>
              <div class="content-tab-container" v-if="productList['Genetic Test']">
                <div v-for="(store, index) in productList['Genetic Test']" :key="index">
                  <div class="card" v-if="!store.purchased">
                    <div class="card-content">
                      <img v-if="store?.thumbnail_image?.[0]?.url" :src="store.thumbnail_image[0].url" alt=""
                        class="img-thumbnails" />
                      <img :src="Bg15" v-else alt="" />
                      <div>
                        <h4>{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                      </div>
                    </div>
                    <div class="card-hover-content">
                      <div class="card-content-hover">
                        <img
                          v-if="Array.isArray(store?.thumbnail_image) && store.thumbnail_image.length > 0 && store.thumbnail_image[0]?.url"
                          :src="store.thumbnail_image[0].url" class="img-thumbnails" alt="" />
                        <img :src="Bg6" v-else alt="" />
                        <h4 class="text-ellipsis">{{ store.product_name }}</h4>
                        <p class="price">{{ store?.price_string }}</p>
                      </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                      <template v-if="isEpigenetics">
                        <router-link :to="{ name: 'HealthStore', query: { tab: 'ancestrykits' } }" class="active-btn">Requires an ancestry kit</router-link>
                      </template>
                      <template v-else>
                        <!-- AncestryDetails, not bloodTestDetails. A genetic report ships
                             nothing, and BloodDetails is the physical kit flow: it always
                             asks for a delivery address. These two links were copied from
                             the Blood Tests tab below, which is why a digital upgrade was
                             landing on /blood/test/details and being asked where to post
                             it. AncestryDetails has the digital-upgrade path that goes
                             straight to payment, and it takes a slug, not an id. -->
                        <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }" class="active-btn">
                          Order
                        </router-link>
                        <router-link :to="{ name: 'AncestryDetails', params: { slug: store._slug } }"
                          class="blood-btn">Explore</router-link>
                      </template>
                    </div>
                    </div>
                  </div>
                </div>
              </div>
              </template>
            </div>
            <div v-if="activeTabName === 'Blood Tests'">
              <p class="head" v-if="productList['Blood Test']">Discover what your blood can tell you</p>
              <div class="content-tab-container" v-if="productList['Blood Test']">
                <div v-for="(store, index) in productList['Blood Test']" :key="index" class="card">
                  <div class="card-content">
                    <img :src="store?.thumbnail_image[0]?.url" alt="" class="img-thumbnails"
                      v-if="store?.thumbnail_image[0]?.url !== ''" />
                    <img :src="Bg6" v-else alt="" />
                    <div>
                      <h4>{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                  </div>
                  <div class="card-hover-content">
                    <div class="card-content-hover">
                      <img :src="store?.thumbnail_image[0]?.url" class="img-thumbnails" alt=""
                        v-if="store?.thumbnail_image[0]?.url !== ''" />
                      <img :src="Bg6" v-else alt="" />
                      <h4 class="text-ellipsis">{{ store.product_name }}</h4>
                      <p class="price">{{ store?.price_string }}</p>
                    </div>
                    <span class="truncate-text-multiline" v-html="store.product_details"></span>
                    <div class="button-container">
                      <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }" class="active-btn">
                        Order
                      </router-link>
                      <router-link :to="{ name: 'bloodTestDetails', params: { product: store._id } }"
                        class="blood-btn">Explore</router-link>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-4 store-nodata" v-else>
                <img :src="DrHenry" class="store-nodata-img" alt="DrHenry" />
                <div class="store-nodata-text">
                  Data not found
                </div>
              </div>
            </div>

            <ClearAllStoreItems v-if="clearAll" :combinedStoreList="combinedStoreList"
              :productStoreList="productStoreList" :clearAll="clearAll" :Bg1="Bg1" :Bg6="Bg6" />

            <CollectionMethod :isModalVisible="isModalVisible" :product="productData"
              @openSubscriptionModal="openSubscriptionModal" @close="closeModal"
              @collection-method="setCollectionMethod" />

            <ModalView :isVisible="isSubscriptionVisible" :title="'Order'" @close="closeSubscriptionModal">
              <SubscriptionModal :isModalVisible="isSubscriptionVisible" @openCheckoutModal="openCheckoutModal"
                :product="productData" :collection-method="collectionMethod" @back="backFromSubscriptionModal" />
            </ModalView>

            <CheckoutModal :isModalVisible="isCheckoutVisible" @close="closeCheckoutModal"
              @openPaymentModal="openPaymentModal" @openPaymentCardModal="openPaymentCardModal"
              @back="backFromCheckoutModal" :contactDetails="contactDetails" :address="address"
              :region="selectedRegion" />

            <PaymentModal :isModalVisible="isPaymentVisible" @close="closePaymentModal"
              @order="order"
              @openPaymentCardModal="openPaymentCardModal" @back="PaymentbackModal"
              :contactDetails="contactDetails" :product="productData" />

            <PaymentCardModal :isModalVisible="isPaymentCardVisible" :contactDetails="contactDetails"
              :product="productData" :delivered="delivered" @closeCardModal="closeCardModal"
              @closePaymentCardModal="closePaymentCardModal" @order="order" @back="PaymentcardbackModal" />

            <ModalView :isVisible="isSuccessVisible" :title="'Payment'">
              <SuccessModal :orderKey="orderKey" />
            </ModalView>

            <ModalView :isVisible="isFailedVisible" :title="'Payment'" @close="closeFailedModal">
              <FailedModal @close="closeFailedModal" />
            </ModalView>

          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useRoute, useRouter } from "vue-router";
import Header from "@/components/header/Header.vue";
import { getAllProducts, getEpigeneticProducts } from "@/store/store/store";
import { statusWithoutResults } from "@/services/kitService";
import UpgradesUnavailable from "@/components/store/UpgradesUnavailable.vue";
import GeneticReportsNotice from "@/components/kit/GeneticReportsNotice.vue";
import WellbeingRequiredPrompt from "@/components/store/WellbeingRequiredPrompt.vue";
import { useWellbeingResults } from "@/composables/useWellbeingResults";
import { useAncestryKit } from "@/composables/useAncestryKit";
import "@/styles/pages/HealthStore.scss";
import Icon1 from "@/assets/images/Store/solar_medical-kit-broken (1).png";
import Icon1Active from "@/assets/images/Store/solar_medical-kit-broken.png";
import Icon2 from "@/assets/images/Store/Mask group (3).png";
import Icon2Active from "@/assets/images/Store/Mask group (4).png";
import Icon3 from "@/assets/images/Store/Mask group (5).png";
import Icon3Active from "@/assets/images/Store/Mask group (6).png";
import Icon4 from "@/assets/images/Store/Mask group (68).png";
import Icon4Active from "@/assets/images/Store/Mask group (7).png";
import Icon5 from "@/assets/images/Store/Mask group (69).png";
import Icon5Active from "@/assets/images/Store/Mask group (70).png";
import BookIcon from "@/assets/images/Store/book.svg";
import BookIconActive from "@/assets/images/Store/book-active.svg";
import IconEpigenetics from "@/assets/images/Store/epigenetic-kits.svg";
import IconEpigeneticsActive from "@/assets/images/Store/epigenetic-kits-active.svg";
import DrHenry from "@/assets/images/Store/DrHenry.png";
import Bg1 from "@/assets/images/Store/image.png";
import Bg3 from "@/assets/images/Store/imagex.png";
import Bg4 from "@/assets/images/Store/image2x.png";
import Bg6 from "@/assets/images/Store/image (8)00.png";
import Bg15 from "@/assets/images/Store/image (10)991.png";
import { usePatientStore } from "@/store/health/blood";
import { groupBy, first } from "lodash";
import ProductService from "@/services/product";
import ClearAllStoreItems from "./ClearAllStoreItems.vue";
import store from '@/store/index'
import { useLoading } from "@/composables/useLoading";
import ModalView from "@/components/Modal/ModalView.vue";

import CollectionMethod from "@/view/health/Blood/Modal/CollectionMethod.vue";
import SubscriptionModal from "@/view/health/Blood/Modal/SubscriptionModal.vue";
import CheckoutModal from "@/view/health/Blood/Modal/CheckoutModal.vue";
import PaymentModal from "@/view/health/Blood/Modal/PaymentModal.vue";
import PaymentCardModal from "@/view/health/Blood/Modal/PaymentCard.vue";
import FailedModal from "@/view/health/Blood/Modal/FailedModal.vue";
import SuccessModal from "@/view/health/Blood/Modal/SuccessModal.vue";
import { useNewWellbeing, checkProfileManager } from '@/services/health/health';

const patientStore = usePatientStore();
const productList = ref([]);
const selectedCategories = ref([]);
const allCategories = ref([]);
const clearData = ref([]);
const { loadingStatus, finishLoading, resetLoading } = useLoading();
const isModalVisible = ref(false);
const productData = ref({});
const products = ref([]);
const buildVersion = store.getters.profile.chipType?.type;
const hasHealthProfileAccess = ref(true);

const storeList = ref({});
// Using ref to track the selected tab and backgrounds
const route = useRoute();
const router = useRouter();
const selectedTab = ref(0);
const profileRegion = computed(() => store.getters?.profile?.profile?.region || "GBR");
const regionOptions = [
  { code: "GBR", label: "United Kingdom", flagSrc: "/svg/flags/round--uk.svg" },
  { code: "USA", label: "United States", flagSrc: "/svg/flags/round--us.svg" },
  { code: "EUR", label: "Europe", flagSrc: "/svg/flags/round--eu.svg" },
  { code: "AUS", label: "Australia", flagSrc: "/svg/flags/round--au.svg" },
  { code: "NZL", label: "New Zealand", flagSrc: "/svg/flags/round--nz.svg" },
  { code: "CAN", label: "Canada", flagSrc: "/svg/flags/round--ca.svg" },
  { code: "INT", label: "International", flagSrc: "/svg/flags/round--row.svg" },
];
const selectedRegion = ref("GBR");
const regionStorageKey = "store_region_override";
const isHydratingRegion = ref(true);
const showRegionDropdown = ref(false);
const regionSwitcherRef = ref(null);
const portalAncestryKits = [
  "Members-Ancestry-Kit",
  "Members-Ancestry-Wellbeing-Kit",
  "Members-Wellbeing-Kit",
];
const portalKits = [...portalAncestryKits];
const craftCategories = ["Digital upgrade", "Kit", "Vitamins supplement", "Merchandise"];

/**
 * Is this one of the epigenetic kits?
 *
 * The sku is the best answer when we have one, but we do not always: ecommerce only sets it
 * when the product has a default variant for the requested region
 * (ProductServiceImpl.modifyResponse), so a kit with no regional variant arrives with
 * sku: null. Matching on that alone made the product fail this test, fail productIsSaleable
 * with it, and vanish from the tab with nothing said - the store showed two kits where
 * Craft held three.
 *
 * Slug and title are always present, so they stand in. The sku still wins when it is there,
 * which leaves every product that already had one behaving exactly as before.
 */
function isEpigeneticKitProduct(product) {
  const identifier = (product?.sku || product?.slug || product?.title || '').toUpperCase();
  return identifier.includes('EPIGENETIC') && !(identifier.includes('DIGITAL') && identifier.includes('UPGRADE'));
}

function productIsSaleable(product, NewWellbeing) {
  const isExcludedSlug =
    product.slug === "Wellbeing-Upgrade" ||
    product.slug === "Members-Ancestry-Wellbeing-Kit" ||
    product.slug === "Members-Wellbeing-Kit";

  if (NewWellbeing || buildVersion === "dnanalysis") {
    return (product.categories !== "Kit" && product.slug !== "Wellbeing-Upgrade") ||
      ((portalKits.includes(product.slug) || isEpigeneticKitProduct(product)) && !isExcludedSlug);
  }
  return product.categories !== "Kit" || portalKits.includes(product.slug) || isEpigeneticKitProduct(product);
}

const tabs = computed(() => {
  if (buildVersion === 'dnanalysis') {
    return [{ name: "Digital Upgrades", icon: Icon3, activeIcon: Icon3Active }];
  }
  const tabList = [
    { name: "Ancestry Kits", icon: Icon1, activeIcon: Icon1Active },
    { name: "Epigenetic Kits", icon: IconEpigenetics, activeIcon: IconEpigeneticsActive },
  ];
  // Digital upgrades are only sold from the ancestry store. Epigenetics sells
  // its upgrades contextually alongside the results, so hide this tab there.
  if (!isEpigenetics.value) {
    tabList.push({ name: "Digital Upgrades", icon: Icon3, activeIcon: Icon3Active });
  }
  if (!isEpigenetics.value) {
    tabList.push({ name: "Merchandise", icon: BookIcon, activeIcon: BookIconActive });
  }
  if (!isEpigenetics.value && hasHealthProfileAccess.value && !useNewWellbeing.value) {
    tabList.push({ name: "Vitamin Supplement", icon: Icon2, activeIcon: Icon2Active });
  }
  if (!isEpigenetics.value && hasHealthProfileAccess.value) {
    tabList.push({ name: "Health Reports", icon: Icon5, activeIcon: Icon5Active });
  }
  if (hasBloodTests.value && hasHealthProfileAccess.value) {
    tabList.push({ name: "Blood Tests", icon: Icon4, activeIcon: Icon4Active });
  }
  return tabList;
});
const normalizeTabName = (value) => String(value || "")
  .toLowerCase()
  .replace(/[^a-z0-9]+/g, "");

const resolveTabIndex = (tabParam) => {
  if (tabParam === undefined || tabParam === null || tabParam === "") return 0;
  const numericIndex = parseInt(tabParam, 10);
  if (!Number.isNaN(numericIndex)) {
    const maxIndex = tabs.value.length - 1;
    if (numericIndex < 0 || numericIndex > maxIndex) return 0;
    return numericIndex;
  }
  const normalizedParam = normalizeTabName(tabParam);
  const matchIndex = tabs.value.findIndex((tab) =>
    tab && normalizeTabName(tab.name) === normalizedParam
  );
  return matchIndex >= 0 ? matchIndex : 0;
};
const hasBloodTests = computed(() => Boolean(productList.value?.["Blood Test"]?.length));
const isBloodSupportedInRegion = computed(() => selectedRegion.value === "GBR");

// True when the active profile is an epigenetics kit (barcode ends with 'E')
const isEpigenetics = computed(() => store.getters?.profile?.profile?.barcode?.endsWith('E') === true);

// Upgrades are sold for the selected profile's kit; none for a kit that will never give results.
const profileBarcode = computed(() => store.getters?.profile?.profile?.barcode);
const upgradesBlockedFor = computed(() => {
  const test = store.getters.selectedTest;
  return test?.barcode === profileBarcode.value ? statusWithoutResults(test) : null;
});

// Genetic health reports are made from the kit's or upload's DNA results: none to sell before
// they're in. An epigenetics kit has its own "Requires an ancestry kit" instead.
const { pending: kitPending, uploadPending } = useAncestryKit();
const reportsWaitForResults = computed(() => !isEpigenetics.value && (kitPending.value || uploadPending.value));

// Personalised vitamins are mixed from the full Wellbeing test's results: none to sell before then
const { known: wellbeingKnown, hasResults: hasWellbeingResults } = useWellbeingResults();
const vitaminsNeedWellbeing = computed(() => wellbeingKnown.value && !hasWellbeingResults.value);

const activeTabName = computed(() => tabs.value[selectedTab.value]?.name ?? '');

const ancestryKitList = computed(() => storeList.value['Kit']?.filter(p => portalAncestryKits.includes(p.slug)) ?? []);
const epigeneticKitList = computed(() => {
  const kits = storeList.value['Kit']?.filter(p => isEpigeneticKitProduct(p)) ?? [];
  // A kit with no sku has no price either - both come off the same variant - so it cannot
  // be bought and is not offered. Say so: this is a content gap in Craft, and the whole
  // reason it took so long to find was that the product simply disappeared.
  const unsellable = kits.filter(p => !p.sku);
  if (unsellable.length) {
    console.warn(
      '[Store] epigenetic kits hidden because they have no sku or price for this region ' +
      '(check they have a variant for it in Craft):',
      unsellable.map(p => p.slug || p.title)
    );
  }
  return kits.filter(p => p.sku);
});

const digitalUpgradeList = computed(() => {
  // Digital upgrades are only surfaced in the ancestry store; epigenetics sells
  // its upgrades contextually with the results, so this tab isn't shown there.
  const items = storeList.value['Digital upgrade'] || [];
  return items.filter(s => !!s.url);
});
const currentRegionOption = computed(
  () => regionOptions.find(({ code }) => code === selectedRegion.value) || regionOptions[0]
);
const tabCountClass = computed(() => `tab-module-wrapper-health-store-${tabs.value.length}`);

const closeModal = () => {
  isModalVisible.value = false;
}
function selectTab(index) {
  clearAll.value = false;
  selectedTab.value = index;
  const tab = tabs.value[index];
  const tabSlug = tab ? normalizeTabName(tab.name) : "";
  router.replace({
    name: "HealthStore",
    query: tabSlug ? { tab: tabSlug } : {},
  });
}
const clearAll = ref(false);

/* function handleClearAll() {
  clearAll.value = true;
  selectedTab.value = null;
} */

const getPrice = (price) => {
  if (price && price.isOnSale) {
    return price.sale / 100;
  }
  if (price && price.base) {
    return price.base / 100;
  }
  if (price === 0) {
    return "FREE";
  }
  return 0;
}
const buttonText = (category, store) => {
  switch (category) {
    case "Merchandise": {
      const merchandiseItems = storeList?.value?.Merchandise || [];
      const lockedItem = merchandiseItems.find((item) => item.locked);

      if (lockedItem) {
        const dependentSlug = first(store.dependentProducts)?.slug;
        const requiredProduct = products.value.find((item) => item.slug === dependentSlug);
        return `Requires ${requiredProduct?.title}`;
      }
      return "Purchase";
    }
    case "Digital upgrade":
      return "Upgrade";
    default:
      return "Purchase";
  }
}

const getDesc = (desc) => {
  const description = desc ? desc.replace(/<\/?[^>]+(>|$)/g, "") : "";
  console.log("description", description);
  return description;

}

const loadStoreData = async () => {
  resetLoading();
  const Barcode = store.getters?.profile?.profile?.barcode;
  let data = [];
  try {
    if (store.getters?.profile?.permission?.type === 'MANAGER') {
      hasHealthProfileAccess.value = await checkProfileManager(Barcode);
    }
    const kitSku = store.getters.selectedTest?.product_sku;
    const craftRequests = craftCategories.map((category) =>
      ProductService.getAllProducts(Barcode, {
        category,
        region: selectedRegion.value,
        ...(kitSku ? { kitSku } : {}),
      })
    );
    const craftResults = await Promise.allSettled(craftRequests);
    data = craftResults
      .filter((result) => result.status === "fulfilled")
      .flatMap((result) => result.value || []);
    products.value = data;
  } catch (error) {
    console.error('Error fetching product data:', error);
  }
  if (data) {
    const saleableProducts = data.filter(product => {
      return productIsSaleable(product, useNewWellbeing.value);
    });
    const nonPurchasedProducts = saleableProducts.filter(product => {
      return product.purchased === false; // Filter by `purchase: false`
    });
    storeList.value = groupBy(nonPurchasedProducts, "categories");
  }

  if (buildVersion !== "dnanalysis") {
    try {
      await patientStore.getPatient();
    } catch (e) {
      console.log(e);
    }
    Promise.all([
      getAllProducts({
        region: selectedRegion.value,
        barcode: Barcode,
        where: {
          age_tags_any: ["All-Ages", patientStore.patient.ageGroup],
          gender_tags_any: [patientStore.patient.bioSex],
          wellbeing_goal_tags_any: patientStore.patient.questionnaireAnswers?.wellbeing_goals,
        },
      }),
      getEpigeneticProducts()
    ])
      .then(([graphqlProducts, epigeneticProducts]) => {
        console.log('🔍 DEBUG: RAW GRAPHQL PRODUCTS:', graphqlProducts);
        console.log('🔍 DEBUG: RAW EPIGENETIC PRODUCTS:', epigeneticProducts);
        
        // Combine both product sources
        const allProducts = [...graphqlProducts, ...epigeneticProducts];
        console.log('🔍 DEBUG: COMBINED PRODUCTS:', allProducts);
        console.log('🔍 DEBUG: Total products count:', allProducts.length);

        const groupedProducts = groupBy(
          allProducts,
          "product_type"
        );

        console.log('🔍 DEBUG: GROUPED PRODUCTS:', groupedProducts);
        console.log('🔍 DEBUG: Product types found:', Object.keys(groupedProducts));

        const filteredGroupedProducts = {};

        Object.keys(groupedProducts).forEach((key) => {
          filteredGroupedProducts[key] = groupedProducts[key].filter(
            (product) => product.purchased !== true
          );
        });

        console.log('🔍 DEBUG: FILTERED PRODUCTS (non-purchased):', filteredGroupedProducts);
        console.log('🔍 DEBUG: Epigenetic products:', filteredGroupedProducts['Epigenetic']);
        console.log('🔍 DEBUG: Epigenetic count:', filteredGroupedProducts['Epigenetic']?.length || 0);

        if (!isBloodSupportedInRegion.value) {
          delete filteredGroupedProducts["Blood Test"];
        }

        productList.value = filteredGroupedProducts;
        clearData.value = filteredGroupedProducts;
        selectedCategories.value = Object.keys(productList.value);
        
        console.log('🔍 DEBUG: FINAL productList.value:', productList.value);
        console.log('🔍 DEBUG: Available categories:', selectedCategories.value);

        if (data && Array.isArray(data) && data.length > 0) {
          const dataCategories = Object.keys(storeList.value);
          allCategories.value = [...selectedCategories.value, ...dataCategories];
        }
        
        console.log('🔍 DEBUG: All categories combined:', allCategories.value);
      })
      .finally(() => {
        finishLoading();
      });
  } else {
    finishLoading();
  }
};

const applyRegion = (regionCode) => {
  const validRegion = regionOptions.some(({ code }) => code === regionCode) ? regionCode : "GBR";
  selectedRegion.value = validRegion;
  localStorage.setItem(regionStorageKey, validRegion);
};

const toggleRegionDropdown = () => {
  showRegionDropdown.value = !showRegionDropdown.value;
};

const selectRegion = (regionCode) => {
  applyRegion(regionCode);
  showRegionDropdown.value = false;
};

const handleRegionClickOutside = (event) => {
  if (regionSwitcherRef.value && !regionSwitcherRef.value.contains(event.target)) {
    showRegionDropdown.value = false;
  }
};

onMounted(async () => {
  document.addEventListener("click", handleRegionClickOutside);
  const storedRegion = localStorage.getItem(regionStorageKey);
  applyRegion(storedRegion || profileRegion.value || "GBR");
  await loadStoreData();
  isHydratingRegion.value = false;
});

onBeforeUnmount(() => {
  document.removeEventListener("click", handleRegionClickOutside);
});

watch(profileRegion, (newRegion) => {
  const storedRegion = localStorage.getItem(regionStorageKey);
  if (!storedRegion) {
    applyRegion(newRegion || "GBR");
  }
});

watch(selectedRegion, () => {
  if (isHydratingRegion.value) return;
  loadStoreData();
});

watch([tabs, () => route.query.tab, () => route.params.tab], () => {
  const tabParam = route.query.tab ?? route.params.tab;
  selectedTab.value = resolveTabIndex(tabParam);
}, { immediate: true });

const combinedStoreList = computed(() => {
  if (clearAll.value) {
    const storeItems = Object.values(storeList.value).flat();
    return [...storeItems];
  }
  return [];
});

const productStoreList = computed(() => {
  if (clearAll.value) {
    const storeItems = Object.values(clearData.value).flat();
    return [...storeItems];
  }
  return [];
});

const isSubscriptionVisible = ref(false);
const isCheckoutVisible = ref(false);
const isPaymentVisible = ref(false);
const isPaymentCardVisible = ref(false);

const address = ref({});
const contactDetails = ref({});
const delivered = ref({});
const isSuccessVisible = ref(false);
const isFailedVisible = ref(false);
const orderKey = ref("");
const collectionMethod = ref();

const setCollectionMethod = (methodId) => {
  collectionMethod.value = methodId;
}

const openSubscriptionModal = (value = null) => {
  if (value === 'Genetic Test') {
    isCheckoutVisible.value = true;
  }
  else {
    isSubscriptionVisible.value = true;
  }
}
const closeSubscriptionModal = () => {
  isSubscriptionVisible.value = false;
}

const backFromSubscriptionModal = () => {
  closeSubscriptionModal();
  isModalVisible.value = true;
}

const PaymentbackModal = () => {
  isCheckoutVisible.value = true;
  isPaymentVisible.value = false;
}
const PaymentcardbackModal = () => {
  isPaymentVisible.value = true;
  isPaymentCardVisible.value = false;
}
const backFromCheckoutModal = () => {
  isSubscriptionVisible.value = true;
  isCheckoutVisible.value = false;
}

const openCheckoutModal = (value = {}) => {
  contactDetails.value = {
    ...contactDetails.value,
    ...value
  };
  closeSubscriptionModal();
  isCheckoutVisible.value = true;
}

const closeCheckoutModal = () => {
  isCheckoutVisible.value = false;
}

const openPaymentModal = (value) => {
  contactDetails.value = {
    ...contactDetails.value,
    ...value
  };
  delivered.value = value;
  isPaymentVisible.value = true;
  isCheckoutVisible.value = false;
}

const closePaymentModal = () => {
  isPaymentVisible.value = false;
}

const closeFailedModal = () => {
  isFailedVisible.value = false;
}

const openPaymentCardModal = (updatedContactDetails) => {
  isPaymentCardVisible.value = true;
  isPaymentVisible.value = false;
  contactDetails.value = updatedContactDetails;
};

const order = (value = null) => {
  if (!value) return;
  const resolvedOrderKey =
    value?.order?.orderKey ||
    value?.orderKey ||
    value?.data?.order?.orderKey ||
    value?.data?.orderKey ||
    null;

  if (resolvedOrderKey) {
    orderKey.value = resolvedOrderKey;
  }

  isPaymentVisible.value = false;
  isPaymentCardVisible.value = false;
  isFailedVisible.value = false;
  isSuccessVisible.value = true;
};

const closeCardModal = () => {
  isPaymentCardVisible.value = false;
}

const closePaymentCardModal = (value) => {
  isPaymentCardVisible.value = false;

  if (value?.paymentIntent?.status == "succeeded") {
    isSuccessVisible.value = true;
  } else {
    isFailedVisible.value = true;
  }
};
</script>
<style lang="scss" scoped>
// In place of a tab's products: a prompt to the way to get them
.store-prompt {
  max-width: 640px;
  margin: 24px auto;
}

.store-nodata {
  display: flex;
  align-items: center;
  margin-inline: auto;
  padding-top: 60px;

  &-img {
    max-width: 240px;
    margin-right: -100px;
    position: relative;
    z-index: 1;
  }

  &-text {
    color: #fff;
    font-size: 26px;
    font-weight: 700;
    letter-spacing: 3px;
    font-family: "Poppins";
    padding: 80px;
    background: linear-gradient(179.98deg, #694BF9 37.12%, #CC6DDF 99.98%);
    box-shadow: -7px 4px 17px 0px rgba(0, 0, 0, 0.0784313725);
    transform: skewX(-5deg);
    max-width: 900px;
  }
}

@media screen and (max-width:1200px) {
  .store-nodata {
    &-img {
      max-width: 220px;
    }

    &-text {
      font-size: 20px;
      max-width: 600px;
    }
  }
}

@media screen and (max-width:767px) {
  .store-nodata {
    &-img {
      max-width: 130px;
      margin-right: -50px;
    }

    &-text {
      font-size: 16px;
      max-width: initial;
      padding: 30px;
      padding-left: 70px;
    }
  }
}

@media screen and (max-width:549px) {
  .store-nodata {
    &-img {
      max-width: 100px;
      margin-right: -50px;
    }

    &-text {
      font-size: 14px;
      max-width: initial;
      padding-left: 50px;
      transform: skewX(-2deg);
    }
  }
}

@media screen and (max-width:400px) {
  .store-nodata {
    flex-direction: column;

    &-img {
      margin-right: 0;
      margin-bottom: -37px;
    }

    &-text {
      padding-left: 30px;
      padding-top: 40px;
    }
  }
}
</style>
